// extracted by mini-css-extract-plugin
export default {"answer":"Questions_answer__VRdUw"};